/**
 * Conference-safe export lock (temporary).
 * TODO: Re-enable with location-based membership entitlements after conference.
 */
export const MEMBER_EXPORTS_LOCKED = true;

/** Roles that bypass MEMBER_EXPORTS_LOCKED (staff demo / admin workflows). */
export const MEMBER_EXPORT_BYPASS_ROLES = ['super_admin', 'local_govt_admin'] as const;

export const CLIMATEPLANS_DATA_USE_NOTICE =
  "ClimatePlans data and figures are provided by UC Berkeley's CoolClimate Network. Redistribution, resale, automated harvesting, or commercial republication requires permission.";

export const MEMBER_EXPORT_LOCK_MESSAGE =
  'Data downloads, figure exports, and customized reports are available through CoolClimate Network membership.';

export const MEMBER_EXPORT_LOCK_SUBTEXT =
  'Public dashboards and chart tooltips remain free to explore.';

export const MEMBERSHIP_APPLY_PATH = '/membership/apply';
export const SCHEDULE_DEMO_PATH = '/demo';
